import { loadStripe, type Stripe } from '@stripe/stripe-js';

import { RUNTIME_CONFIG } from './runtime-config';

let stripePromise: Promise<Stripe | null> | undefined;

/**
 * Stripe.js, loaded once and only when a screen actually needs it (ESCLOUD-283)
 * — loadStripe injects the js.stripe.com script tag at call time, and most
 * sessions never reach checkout.
 *
 * `null` means "Stripe is not wired in this environment" (no publishable key
 * in the runtime config). Callers must treat that as payments being
 * unavailable — never as free.
 *
 * The Tax ID Element (organization checkouts) is a preview with Checkout
 * Sessions: without its beta flag the checkout SDK has no
 * `createTaxIdElement`, and mounting `<TaxIdElement>` throws.
 * https://docs.stripe.com/elements/tax-id-element?payment-ui=embedded-components
 */
export function getStripe(): Promise<Stripe | null> | null {
    if (!RUNTIME_CONFIG.stripePublishableKey) {
        return null;
    }
    stripePromise ??= loadStripe(RUNTIME_CONFIG.stripePublishableKey, {
        betas: ['custom_checkout_tax_id_1'],
    });
    return stripePromise;
}
